import { h, createRef, Fragment } from "preact";
import { useState } from "preact/hooks";

import AutoSuggest from "./AutoSuggest.jsx";
import Icon from "./Icon.jsx";
import Tag from "./Tag.jsx";
import { sendError } from "../errors.js";

export default function MultiSelect({
  onChange,
  onInput,
  onRemove,
  values,
  max,
  suggestions,
  onlySuggestions,
  ...inputProps
}) {
  const ref = createRef();
  const [currentValue, setCurrentValue] = useState("");

  function handleChange(eventOrValue) {
    const value =
      typeof eventOrValue === "string"
        ? eventOrValue
        : eventOrValue.target.value;
    setCurrentValue(value || "");
  }

  function handleKeyDown(event) {
    // Prohibit closing of question on enter
    if (event.code === "Enter") {
      event.preventDefault();
    }
  }

  function handleKey(event) {
    if (event.code === "Enter") {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    // Don’t do anything if already at max
    if (max && values.length === max) {
      return;
    }

    if (event.code === "Enter") {
      if (
        currentValue &&
        (!onlySuggestions ||
          suggestions.findIndex(
            ({ text }) =>
              currentValue.localeCompare(text, "en", {
                sensitivity: "base",
              }) === 0
          ) !== -1)
      ) {
        onChange(currentValue);
        setCurrentValue("");
      }
    }
  }
  function handleSelection({ value }) {
    // Don’t do anything if already at max
    if (max && values.length === max) {
      return;
    }

    onChange(value);
    setTimeout(() => {
      setCurrentValue("");
    }, 10);
  }
  function filterSuggestions(suggestions) {
    try {
      return suggestions.filter(({ value }) => !values.includes(value));
    } catch (err) {
      sendError(err);
      return suggestions;
    }
  }

  return (
    <Fragment>
      <AutoSuggest
        suggestions={filterSuggestions(suggestions)}
        inputProps={inputProps}
        value={currentValue}
        onChange={handleChange}
        onSelect={handleSelection}
        ref={ref}
        onKeyUp={handleKey}
        onKeyDown={handleKeyDown}
        showCaret={onlySuggestions}
      />
      {values.map((value) => (
        <Tag
          noHover
          iconBack={
            <Icon
              small
              class="icon--clickable"
              onClick={(event) => onRemove(value)}
            >
              close
            </Icon>
          }
          class="mr-12 mb-12"
        >
          {value}
        </Tag>
      ))}
    </Fragment>
  );
}
